import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { HelpListPopupComponent } from 'app/EMR/Doctor/doctor-other-info/help-list-popup/help-list-popup.component';
import { EMRService } from 'app/EMR/EMR.service';
import { DiseaseModel } from 'app/EMR/HistoryModels/disease.model';
import { FamilyHistoryModel } from 'app/EMR/HistoryModels/familyhistory.model';
import { HelplistService } from 'app/helplist.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { error } from 'console';
import { Observable, Subject } from 'rxjs';
import { startWith, map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-family-history',
  templateUrl: './family-history.component.html',
  styleUrls: ['./family-history.component.scss']
})
export class FamilyHistoryComponent implements OnInit {
  private familyhistory_ds: MatTableDataSource<FamilyHistoryModel>
  private filteredOptions_diseases: Observable<DiseaseModel[]>;
  private filteredOptions_diseasesedit: Observable<DiseaseModel[]>;
  private DiseaseControl = new FormControl();
  private DiseaseControledit = new FormControl();
  private displayedColumns_familyhistory: string[] = ['diseasename', 'startdate', 'recoveron', 'relation', 'comments', 'Action'];
  private fenabledisablebtn: boolean = false;
  private disabled: boolean = false;
  private destroyfamily$: Subject<boolean> = new Subject<boolean>();
  private editCache: { [key: string]: any } = {};
  private alldisease: any;
  private commentArray: any[];
  private EditId: any;

  constructor(private emrservice: EMRService,
    private dashboardService: DashboardService, private datePipe: DatePipe, private helplistservice: HelplistService,
    private opdvisitService: OpdVisitService, private dialog: MatDialog, private authService: AuthService,) {
    this.filteredOptions_diseases = this.DiseaseControl.valueChanges
      .pipe(
        startWith(null),
        map(disease => disease ? this._filterdiseases(disease) : this.alldisease.slice())
      );
  }

  ngOnInit(): void {
    this.fenabledisablebtn = true;
    this.familyhistory_ds = new MatTableDataSource(this.emrservice.familyhistory.slice());
    
    this.alldisease = this.helplistservice.diseaseList.filter(item => item.diseaseName != null && item.isActive == true);
    this.updateEdit();
    // this.getDyanamicHelplist();
    this.filteredOptions_diseasesedit = this.DiseaseControledit.valueChanges
      .pipe(startWith(null),
        map(disease => disease ? this._filterdiseases(disease) : this.alldisease.slice())
      );

  }

  get_familyhistory() {
    this.emrservice.get_familyhistory().pipe(takeUntil(this.destroyfamily$)).subscribe(
      data => this.success_familyhistory(data), err => this.failed_familyhistory(err)
    )

  }

  success_familyhistory(data) {
    this.emrservice.familyhistory = data;
    this.familyhistory_ds = new MatTableDataSource(this.emrservice.familyhistory.slice());
    this.updateEdit();
  }

  failed_familyhistory(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  deletefamilyhistory(row) {
    if (this.emrservice.familyhistoryPermission?.isDeletePermission == true) {
      let tranId = row.pkTranId;
      if (tranId > 0) {
        this.emrservice.delete_familyhistory_on_server(tranId).pipe(takeUntil(this.destroyfamily$)).subscribe(
          data => this.success_delete_familyhistory(data), err => this.failed_delete_familyhistory(err)
        )
      } else {
        const index: number = this.emrservice.familyhistory.indexOf(row);
        if (index !== -1) {
          this.emrservice.familyhistory.splice(index, 1);
          this.familyhistory_ds = new MatTableDataSource(this.emrservice.familyhistory.slice());
        }
      }
    } else {
      this.dashboardService.openSnackBar("Delete permission denied", "OK");
    }
  }

  chknewrecords() {
    if (this.emrservice.familyhistory.find(item => item.pkTranId == 0)) {
      return false;

    }
    else {
      return true;
    }
  }

  success_delete_familyhistory(data) {
    this.fenabledisablebtn = true;
    this.get_familyhistory();
    this.emrservice.getHistoryStatus(this.emrservice.visitid);
    this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
  }

  failed_delete_familyhistory(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  getToday(): string {
    return this.authService.getServerDate;
  }
  getStartdate(): string {
    return this.emrservice.familyhistory_added.startDate;
  }
  getStartdateEdit(index): string {
    const id = index;
    return this.editCache[id].data.startDate;
  }
  DisableDate() {
    // this.disabled = true;
    this.emrservice.familyhistory_added.recoveryon = '';

  }
  addfamilyhistory() {
    if (this.emrservice.familyhistory_added.diseaseName == undefined) {
      return this.dashboardService.openSnackBar("Please select at least one disease ", "Ok")
    }
    if(this.emrservice.familyhistory_added.diseaseName.toLowerCase() != 'nil' && this.emrservice.familyhistory_added.diseaseName.toLowerCase() != 'nill' && this.emrservice.familyhistory_added.diseaseName.toLowerCase() != 'na'){
      if(this.emrservice.familyhistory_added.relation == undefined || this.emrservice.familyhistory_added.relation == null || this.emrservice.familyhistory_added.relation == '') {
        return this.dashboardService.openSnackBar("Please select relation ", "Ok")
      }
    }

    //  else if (this.emrservice.familyhistory_added.startDate > this.emrservice.familyhistory_added.recoveryon) {
    //   return this.dashboardService.openSnackBar("Start date and Recover on should be a past date or today", "Ok");
    // }
    
    const isDuplicate = this.emrservice.familyhistory.some((entry:any) =>{
      return (
        entry.diseaseName.toLowerCase() == this.emrservice.familyhistory_added.diseaseName.toLowerCase() &&
         entry.relation?.toLowerCase() == this.emrservice.familyhistory_added.relation?.toLowerCase()
      );   
     });
    if (isDuplicate) {
      return this.dashboardService.openSnackBar("Already exists in the list ", "Ok")
    }
    this.fenabledisablebtn = false;
    this.set_other_fields_familyhistory();
    this.emrservice.familyhistory.push(this.emrservice.familyhistory_added);
    this.emrservice.familyhistory_added = {};
    this.familyhistory_ds = new MatTableDataSource(this.emrservice.familyhistory.slice());
    this.updateEdit();
    document.getElementById("familyHistoryModal").style.display = "none";
  }

  set_other_fields_familyhistory() {

    if (this.emrservice.familyhistory_added.startDate != null) {
      this.emrservice.familyhistory_added.startDate =
        this.datePipe.transform(this.emrservice.familyhistory_added.startDate, "MM-dd-yyyy").toString();
    }
    if (this.emrservice.familyhistory_added.recoveryon != null && this.emrservice.familyhistory_added.recoveryon != '') {
      this.emrservice.familyhistory_added.recoveryon =
        this.datePipe.transform(this.emrservice.familyhistory_added.recoveryon, "MM-dd-yyyy").toString();
    }

    this.emrservice.familyhistory_added.pkTranId = 0;
    this.emrservice.familyhistory_added.fkRegId = this.opdvisitService.patientdetails.pkRegId;
    this.emrservice.familyhistory_added.pkSynchId = null;
    this.emrservice.familyhistory_added.fkReg = null;
  }
  newdiseaseArray: any = [];
  private _filterdiseases(value: string): DiseaseModel[] {
    if (value && (typeof value != 'number')) {
    const filterValue = value.toLowerCase();
    const returndata =  this.helplistservice.diseaseList.filter
      (disease => disease.diseaseName?.toLowerCase().indexOf(filterValue) === 0);
      if (returndata.length == 0 && value.length >= 3) {
        this.helplistservice.getDiseaseData(value,'A').pipe(takeUntil(this.destroyfamily$)).subscribe((item:any)=>{
          this.newdiseaseArray = [];
          this.newdiseaseArray = item.filter(item=>item.isActive ==true);
          this.filteredOptions_diseases = this.DiseaseControl.valueChanges
          .pipe(
            startWith(""),
            map(cat => this.newdiseaseArray.slice())
          );
          this.filteredOptions_diseasesedit = this.DiseaseControledit.valueChanges
          .pipe(
            startWith(""),
            map(cat => this.newdiseaseArray.slice())
          );
        },err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        })
      }else {
        return returndata;
      }
    }
    //return this.authService.users.filter(ul => ul.userName.toLowerCase().indexOf(filterValue) === 0);
  }

  CheckinputRef(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.emrservice.drugallergy_added.saltName = null;

      this.filteredOptions_diseases = this.DiseaseControl.valueChanges
        .pipe(
          startWith(null),
          map(dis => dis ? this._filterdiseases(dis) : this.alldisease.slice())
        );
    }
  }
 
  saveFamilyHistory() {

    let familyPayload = this.emrservice.familyhistory.filter(item => item.pkTranId == 0);
    if (familyPayload.length > 0) {
      this.emrservice.open_loader_Dialog();
      this.emrservice.save_familyhistory_to_server(familyPayload).pipe(takeUntil(this.destroyfamily$)).subscribe(
        data => this.success_familyhistory_save(data), err => this.failed_familyhistory_save(err)
      );

    } else {
      this.dialog.closeAll();
      return this.dashboardService.openSnackBar("Please Add The Disease ", "Ok");
    }

  }

  success_familyhistory_save(data) {
    this.fenabledisablebtn = true;
    this.dialog.closeAll();
    this.emrservice.getHistoryStatus(this.emrservice.visitid);
    this.get_familyhistory();
     if (data.statusCode == 10) {
      this.dashboardService.openSnackBar("Alreday exists in the list", "OK");
    } else {
      this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
    }
  }
  failed_familyhistory_save(err) {
    this.dialog.closeAll();
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }




  familyHistory() {
    if (this.emrservice.familyhistoryPermission?.isAddPermission == true) {
      document.getElementById("familyHistoryModal").style.display = "block";
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }
  cancelfamilyHistory() {
    document.getElementById("familyHistoryModal").style.display = "none";
    this.emrservice.familyhistory_added = {};
  }

  addFamilylist() {
    this.addfamilyhistory();
    this.filteredOptions_diseases = this.DiseaseControl.valueChanges
        .pipe(
          startWith(null),
          map(dis => dis ? this._filterdiseases(dis) : this.alldisease.slice())
        );
    
  }

  updateEdit(): void {
    this.familyhistory_ds.data.forEach((item, index) => {
      const id = index;
      this.editCache[id] = {
        edit: false,
        data: { ...item }
      };
    });
  }

  Edit(index) {
    if (this.emrservice.familyhistoryPermission?.isModifyPermission == true) {
      const id = index;
      this.EditId = id;
      this.updateEdit();
      this.editCache[id].edit = true;
      // this.getDyanamicHelplist();
      if (this.editCache[id].data.startDate != "1900-01-01T00:00:00") {
        this.editCache[id].data.startDate = this.datePipe.transform(this.editCache[id].data.startDate, "yyyy-MM-dd").toString();

      } else {
        this.editCache[id].data.startDate = null;

      }
      if (this.editCache[id].data.recoveryon != "1900-01-01T00:00:00") {

        this.editCache[id].data.recoveryon = this.datePipe.transform(this.editCache[id].data.recoveryon, "yyyy-MM-dd").toString();
      } else {

        this.editCache[id].data.recoveryon = null;
      }
    } else {
      this.dashboardService.openSnackBar(" Modify permission denied", "OK");
    }
  }

  saveEdit(idx): void {
    const id = idx;
    let payloadarray = [];
    let editpayload;
    let startdate;
    let recoverydate;

    let editlist = this.editCache[id].data;
    if (editlist.startDate != null) {
      startdate = this.datePipe.transform(editlist.startDate, "yyyy-MM-dd").toString();
    }
    if (editlist.recoveryon != null) {
      recoverydate = this.datePipe.transform(editlist.recoveryon, "yyyy-MM-dd").toString();
    }
    payloadarray.push({
      "diseaseName": editlist.diseaseName,
      "startDate": startdate,
      "recoveryon": recoverydate,
      "relation": editlist.relation,
      "comment": editlist.comment,
      "pkTranId": editlist.pkTranId,
      "fkRegId": editlist.fkRegId,
      "pkSynchId": editlist.pkSynchId,
      "fkReg": editlist.fkReg
    });
    this.editCache[id].edit = false;
    editpayload = payloadarray;
    this.emrservice.save_familyhistory_to_server(editpayload).pipe(takeUntil(this.destroyfamily$)).subscribe(
      data => this.success_familyhistory_save(data), err => this.failed_familyhistory_save(err)
    )
  }

  cancelEdit(idx): void {
    const id = idx;
    this.editCache[id].edit = false;
  }

  relationPOpup(type) {
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',
      data: {
        typeid: type
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroyfamily$)).subscribe(result => {
      if (result != 0) {
        if (type == 22) {
          this.emrservice.familyhistory_added.relation = result;
        }
      }
    });
  }

  refReasonPOpup(parameter, type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: parameter
      }

    });


    dialogRef.afterClosed().pipe(takeUntil(this.destroyfamily$)).subscribe(result => {
      if (result != 0) {
        if (type == 1) {
          this.emrservice.familyhistory_added.comment = result;
        } else if (type == 2) {
          this.editCache[this.EditId].data.comment = result;
        }

      }
    });
  }
  ngOnDestroy() {
    this.destroyfamily$.next(true);
    this.destroyfamily$.unsubscribe();
    this.familyhistory_ds = null;
    this.filteredOptions_diseases = null;
    this.filteredOptions_diseasesedit = null;
    this.displayedColumns_familyhistory = null;
    this.editCache = null;
    this.alldisease = null;
    this.commentArray = null;
    this.EditId = null;
  }
}
